// Jeton du tableau de suivi, gardé dans le navigateur (repli en mémoire si
// le stockage est indisponible : navigation privée, cookies bloqués).
const KEY = 'feedbaacks:dashboard:token'
let memory: string | null = null

export function readToken(): string | null {
  try {
    return localStorage.getItem(KEY) ?? memory
  } catch {
    return memory
  }
}

export function writeToken(token: string): void {
  memory = token
  try {
    localStorage.setItem(KEY, token)
  } catch {
    // mémoire seule
  }
}

export function clearToken(): void {
  memory = null
  try {
    localStorage.removeItem(KEY)
  } catch {
    // rien à effacer
  }
}
